module.exports = __webpack_public_path__ + "static/media/hello_img_1.794883e8.png";